import { render, staticRenderFns } from "./DecimalNumber.vue?vue&type=template&id=6f94e412"
import script from "./DecimalNumber.vue?vue&type=script&lang=js"
export * from "./DecimalNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports